module.exports = __webpack_public_path__ + "img/plugin2.cfe9d4cc.png";